/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import PgwIframe from '../../../../components/PgwIframe';
import { showAlert } from '../../../../utilities/notifications';

const FiatWalletDeposit = ({ onCloseModal, options, onPrevClick, refreshWallets }) => {
  const { t: translate } = useTranslation();

  const renderTitle = () => (
    <b className="text-f5 text-dark me-auto">
      {translate('card_order_proceed_with_payment_title')}
    </b>
  );

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={onPrevClick}
      renderTitle={renderTitle}
      isIframe
      renderFooter={() => {}}>
      <div>
        <PgwIframe
          pgwUrl={options?.pgwUrl}
          onPgwResolve={() => {
            showAlert({
              message: translate('transaction_notification_label_success'),
              type: 'success',
            });
            refreshWallets();
            onCloseModal();
          }}
        />
      </div>
    </ModalBodyLayout>
  );
};

export default FiatWalletDeposit;

FiatWalletDeposit.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onPrevClick: PropTypes.func.isRequired,
  refreshWallets: PropTypes.func.isRequired,
};
FiatWalletDeposit.defaultProps = {
  options: null,
};
